import { AbstractControl } from '@angular/forms'

/**
 * Validates a Job title string based on a regex
 * @param control Abstract control
 * @returns error or null
 */
export function ValidateJobTitle(control: AbstractControl) {
  if (/\d/.test(control.value)) {
    return { validJobTitle: true }
  }
  return null
}
